import Route from '@ember/routing/route';
import { service } from '@ember/service';
import type RouterService from '@ember/routing/router';
import type Transition from '@ember/routing/transition';

/**
 * The classic program approval page has been retired. This route is kept only
 * so existing inbound links keep resolving — it redirects to the new program
 * approval surface at `tas/programs/:id`.
 */
export default class AuthenticatedAdminTuitionAssistanceProgramInstancesShowRoute extends Route {
  @service declare router: RouterService;

  beforeModel(transition: Transition) {
    const id = transition.to?.params?.['tas_program_instance_id'];
    if (id) {
      this.router.replaceWith('authenticated.admin.tas.programs', id);
    }
  }
}
